import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    goHome,
    goToAbout,
    goToFAQFabrics,
    goToFAQRecoloring,
    goToFAQShipping,
    goToFavs,
    goToSewpatPatterns,
    goToSewpatGallery,
} from '../../actions/navigation';
import { toggleHeaderMenu } from '../../actions/uiActions';
import { getCurrentLangCode } from '../../reducers/i18n';
import { getActiveSewpatId } from '../../reducers/sewpats';

import DrawerMenu from './DrawerMenu';
import MenuItem from './DrawerMenuItem';
import UnstyledLink from '../styles/UnstyledLink';


const MainMenu = props => {
    const {
        goHome, goToAbout, goToSewpatGallery, goToSewpatPatterns, goToFAQFabrics,
        goToFAQRecoloring, goToFAQShipping, goToFavs, sewpatId, toggleHeaderMenu,
    } = props;

    const mainMenuItems = [
        <MenuItem key='sewpat' handleClick={goToSewpatGallery}>Schnitte</MenuItem>,
        <MenuItem key='patterns' handleClick={() => goToSewpatPatterns(sewpatId)}>Stoffe</MenuItem>,
        <MenuItem key='fabrics' handleClick={goToFAQFabrics}>FAQ Stoffqualitäten</MenuItem>,
        <MenuItem key='shipping' handleClick={goToFAQShipping}>FAQ Versand</MenuItem>,
        <MenuItem key='recoloring' handleClick={goToFAQRecoloring}>FAQ Farben </MenuItem>,
        <MenuItem key='about' handleClick={goToAbout}>Über Schnoffle</MenuItem>];
    const mainMenuItemsEN = [
        <MenuItem key='sewpat' handleClick={goToSewpatGallery}>Sewing Pattern</MenuItem>,
        <MenuItem key='patterns' handleClick={() => goToSewpatPatterns(sewpatId)}>Textile Pattern</MenuItem>,
        <MenuItem key='fabrics' handleClick={goToFAQFabrics}>FAQ Fabrics</MenuItem>,
        <MenuItem key='shipping'handleClick={goToFAQShipping}>FAQ Colors</MenuItem>,
        <MenuItem key='recoloring'handleClick={goToFAQRecoloring}>FAQ Shipping</MenuItem>,
        <MenuItem key='about' handleClick={goToAbout}>About</MenuItem>];

    const subMenuItems = [
        <MenuItem key='favs' handleClick={goToFavs}>Deine Merkliste</MenuItem>,
        <MenuItem key='cart'><UnstyledLink href='https://checkout.stoff.love/cart'>Warenkorb</UnstyledLink></MenuItem>];

    const subMenuItemsEN = [
        <MenuItem key='favs' handleClick={goToFavs}>Your Favorites</MenuItem>,
        <MenuItem key='cart' handleClick={goHome}>Cart</MenuItem>];

    const getMainMenuItems = lang => lang === 'de'
        ? mainMenuItems
        : mainMenuItemsEN;

    const getSubMenuItems = lang => lang === 'de'
        ? subMenuItems
        : subMenuItemsEN;

    return (
        <DrawerMenu
            mainNavigationItems={getMainMenuItems(props.lang)}
            subNavigationItems={getSubMenuItems(props.lang)}
            toggleMenu={toggleHeaderMenu}
        />
    );
};

const mapStateToProps = (state, ownProps) => (
    {
        lang: getCurrentLangCode(state),
        sewpatId: getActiveSewpatId(state),
    }
);

const mapDispatchToProps = dispatch => bindActionCreators({
    goHome,
    goToAbout,
    goToSewpatPatterns,
    goToFAQFabrics,
    goToFAQRecoloring,
    goToFAQShipping,
    goToFavs,
    toggleHeaderMenu,
    goToSewpatGallery,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);



// WEBPACK FOOTER //
// ./src/components/header/MainMenuDrawer.js